window.JRS = window.JRS || {};

(function(JRS) {
  'use strict';

  var EventBus = JRS.EventBus;
  var ConfigurationState = JRS.ConfigurationState;
  var CartPayloadBuilder = JRS.CartPayloadBuilder;
  var CartAPI = JRS.CartAPI;
  var CartValidator = JRS.CartValidator;
  var ProductSelector = JRS.ProductSelector;
  var Customizer = JRS.Customizer;
  var StickyBar = JRS.StickyBar;
  var PDP_TYPES = JRS.PDP_TYPES;
  var PRODUCT_SELECTOR_STRATEGIES = JRS.PRODUCT_SELECTOR_STRATEGIES;

  var _pdpType = null;
  var _strategy = null;
  var _isCustomizable = false;
  var _isProcessing = false;
  var _sectionEl = null;
  var _boundListeners = [];
  var _eventUnsubs = [];
  var _awaitingCustomizationDecision = false;

  function init() {
    destroy();

    var type = _detectPDPType();
    if (!type) return;

    if (type === PDP_TYPES.BUNDLE) {
      _initBundlePDP();
    } else if (_strategy === PRODUCT_SELECTOR_STRATEGIES.MULTI_STEP) {
      _initMultiStepPDP();
    } else {
      _initStandardPDP();
    }

    _wireButtons();
    _wireEvents();
    if (_strategy !== PRODUCT_SELECTOR_STRATEGIES.MULTI_STEP) {
      _initStickyBar();
    }
    _bindBfCacheHandler();
    _setATCButtonState('default');
  }

  function destroy() {
    _destroyListeners();
    _destroyEventSubscriptions();

    if (ProductSelector && typeof ProductSelector.destroy === 'function') {
      try {
        ProductSelector.destroy();
      } catch (error) {
        console.error('[JRSBASE-V8.3.0-09102026-BYOB] JRS PDPController: ProductSelector.destroy failed', error);
      }
    }
    if (StickyBar && typeof StickyBar.destroy === 'function') {
      try {
        StickyBar.destroy();
      } catch (error) {
        console.error('[JRSBASE-V8.3.0-09102026-BYOB] JRS PDPController: StickyBar.destroy failed', error);
      }
    }

    _pdpType = null;
    _strategy = null;
    _isCustomizable = false;
    _isProcessing = false;
    _sectionEl = null;
    _awaitingCustomizationDecision = false;
  }

  function _detectPDPType() {
    _sectionEl = document.querySelector('[data-jrs-pdp-section]');
    if (!_sectionEl) return null;

    var templateType = _sectionEl.getAttribute('data-jrs-template-type');

    if (templateType === 'bundle') {
      _pdpType = PDP_TYPES.BUNDLE;
      _strategy = PRODUCT_SELECTOR_STRATEGIES.BUNDLE_CATEGORY;
    } else if (templateType === 'multi-step' || templateType === 'multistep') {
      _pdpType = PDP_TYPES.STANDARD;
      _strategy = PRODUCT_SELECTOR_STRATEGIES.MULTI_STEP;
    } else {
      _pdpType = PDP_TYPES.STANDARD;
      _strategy = PRODUCT_SELECTOR_STRATEGIES.SINGLE_VARIANT;
    }

    _isCustomizable = _sectionEl.getAttribute('data-jrs-customizable') === 'true';
    return _pdpType;
  }

  function _initStandardPDP() {
    var productJSON = _parseProductJSON();
    if (!productJSON) return;

    var hasMultipleSizes = _sectionEl.getAttribute('data-jrs-multiple-sizes') === 'true';
    var isCombine = _sectionEl.getAttribute('data-jrs-is-combine') === 'true';

    ProductSelector.init(PRODUCT_SELECTOR_STRATEGIES.SINGLE_VARIANT, {
      sectionEl: _sectionEl,
      productJSON: productJSON,
      isCustomized: _isCustomizable,
      isCombine: isCombine,
      hasMultipleSizes: hasMultipleSizes
    });
  }

  function _initMultiStepPDP() {
    var productJSON = _parseProductJSON();
    if (!productJSON) return;

    var multiStepMount = _findMultiStepMount(_sectionEl);
    if (!multiStepMount) {
      console.warn('[JRSBASE-V8.3.0-09102026-BYOB] JRS PDPController: Missing multistep mount selector, falling back to single-variant strategy');
      _strategy = PRODUCT_SELECTOR_STRATEGIES.SINGLE_VARIANT;
      _initStandardPDP();
      return;
    }
    if (_isV2MultiStepOwnedMount(multiStepMount)) {
      console.log('[JRSBASE-V8.3.0-09102026-BYOB] JRS PDPController: v2 multistep mount owner detected; skipping legacy ProductSelector.MULTI_STEP init');
      return;
    }

    ProductSelector.init(PRODUCT_SELECTOR_STRATEGIES.MULTI_STEP, {
      sectionEl: _sectionEl,
      productJSON: productJSON,
      isCustomized: _isCustomizable,
      colorGalleryPairs: window.JRS_COLOR_GALLERY_PAIRS || [],
      galleryMediaIds: window.JRS_GALLERY_MEDIA_IDS || []
    });
  }

  function _initBundlePDP() {
    var bundleData = _parseJSONScript('[data-jrs-bundle-data]');
    var pricing = _parseJSONScript('[data-jrs-bundle-pricing]');
    var colourHexMap = _parseJSONScript('[data-jrs-colour-hex-map]');

    var bundleVariantId = 0;
    if (bundleData && bundleData.variantId) bundleVariantId = Number(bundleData.variantId);
    if (!bundleVariantId && pricing && pricing.variantId) bundleVariantId = Number(pricing.variantId);

    var bundleProductHandle = '';
    if (bundleData && bundleData.productHandle) bundleProductHandle = String(bundleData.productHandle);

    ProductSelector.init(PRODUCT_SELECTOR_STRATEGIES.BUNDLE_CATEGORY, {
      sectionEl: _sectionEl,
      bundleVariantId: bundleVariantId || 0,
      bundleProductHandle: bundleProductHandle,
      bundleMetaobjectId: _sectionEl.getAttribute('data-jrs-bundle-metaobject-id') || '',
      categoryCount: Number(_sectionEl.getAttribute('data-jrs-category-count') || 0),
      totalLimit: Number(_sectionEl.getAttribute('data-jrs-total-limit') || 0),
      colourHexMap: colourHexMap || {}
    });
  }

  function _initStickyBar() {
    if (!StickyBar || typeof StickyBar.init !== 'function') return;
    if (!_sectionEl) return;

    var titleEl = _sectionEl.querySelector('.selector-header__title') || _sectionEl.querySelector('h1');
    var productTitle = titleEl ? (titleEl.textContent || '').trim() : '';
    var priceEl = _sectionEl.querySelector('[data-jrs-bundle-total], .bundle-price, .price-item--regular');
    var price = priceEl ? (priceEl.textContent || '').trim() : '';
    var totalLimit = Number(_sectionEl.getAttribute('data-jrs-total-limit') || 0);

    try {
      StickyBar.init(_pdpType === PDP_TYPES.BUNDLE ? 'bundle' : 'multistep', {
        productTitle: productTitle,
        price: price,
        totalLimit: totalLimit
      });
    } catch (error) {
      console.error('[JRSBASE-V8.3.0-09102026-BYOB] JRS PDPController: StickyBar.init failed', error);
    }
  }

  function _parseProductJSON() {
    var jsonEl = _sectionEl ? _sectionEl.querySelector('[data-product-json], [data-jrs-product-json]') : null;
    if (!jsonEl) {
      // Some templates render product JSON outside the PDP section wrapper.
      jsonEl = document.querySelector('[data-jrs-product-json]') || document.querySelector('[data-product-json]');
    }
    if (!jsonEl) {
      console.error('[JRSBASE-V8.3.0-09102026-BYOB] JRS PDPController: [data-product-json] not found');
      return null;
    }
    try {
      return JSON.parse(jsonEl.textContent);
    } catch (e) {
      console.error('[JRSBASE-V8.3.0-09102026-BYOB] JRS PDPController: Failed to parse product JSON', e);
      return null;
    }
  }

  function _parseJSONScript(selector) {
    var el = _sectionEl ? _sectionEl.querySelector(selector) : null;
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || '{}');
    } catch (e) {
      console.error('[JRSBASE-V8.3.0-09102026-BYOB] JRS PDPController: Failed to parse JSON for ' + selector, e);
      return null;
    }
  }

  /**
   * Support both old and new multistep mount contracts.
   *
   * @param {Element|null} root
   * @returns {Element|null}
   */
  function _findMultiStepMount(root) {
    var scope = root || document;
    return scope.querySelector('[data-jrs-pdp-v2-mount], [data-pdp-v2-mount], [data-jrs-multistep-mount], #pdp-v2-mount');
  }

  function _isV2MultiStepOwnedMount(mount) {
    if (!mount) return false;
    if (mount.getAttribute('data-jrs-multistep-owner') === 'v2') return true;
    return !!mount.querySelector('pdp-multistep-form-v2');
  }

  function _wireButtons() {
    var atcBtn = _sectionEl.querySelector('[data-jrs-atc-button]');
    if (atcBtn) {
      _bindListener(atcBtn, 'click', function(e) {
        e.preventDefault();
        _handleAddToCart();
      });
    }

    var customiseBtn = _sectionEl.querySelector('[data-jrs-customise-button]');
    if (customiseBtn) {
      _bindListener(customiseBtn, 'click', function(e) {
        e.preventDefault();
        _awaitingCustomizationDecision = false;
        Customizer.open();
      });
    }
  }

  function _wireEvents() {
    _eventUnsubs.push(EventBus.on('customization:complete', _onCustomizationComplete));

    _eventUnsubs.push(EventBus.on('customization:cancelled', function() {
      if (_awaitingCustomizationDecision) {
        _awaitingCustomizationDecision = false;
        _handlePlainAddToCart();
      }
    }));

    _eventUnsubs.push(EventBus.on('bundle:allCategoriesCompleted', function() {
      var textEl = _sectionEl ? _sectionEl.querySelector('[data-jrs-atc-text]') : null;
      if (textEl && _isCustomizable) {
        textEl.textContent = 'Add Logo & Customise';
      }
      _setATCButtonEnabled(true);
    }));

    _eventUnsubs.push(EventBus.on('product:sizesChanged', function(data) {
      var totalQuantity = data && typeof data.totalQuantity === 'number' ? data.totalQuantity : 0;
      if (totalQuantity > 0) {
        _setATCButtonEnabled(true);
      }
    }));
  }

  function _bindBfCacheHandler() {
    _bindListener(window, 'pageshow', function(e) {
      if (e && e.persisted) {
        _isProcessing = false;
        _awaitingCustomizationDecision = false;
        ConfigurationState.reset();
        destroy();
        init();
      }
    });
  }

  function _handleAddToCart() {
    if (_isProcessing) return;

    var config = ConfigurationState.getConfiguration();
    var hasCustomization = !!(config && config.customization);

    if (_isCustomizable && !hasCustomization) {
      _awaitingCustomizationDecision = true;
      Customizer.open();
      return;
    }

    var readiness = ConfigurationState.isReady();
    if (!readiness.ready) {
      _showNotification(readiness.reason || 'Please complete product selection before adding to cart.', 'error');
      return;
    }

    _executeAddToCart();
  }

  function _handlePlainAddToCart() {
    ConfigurationState.clearCustomization();

    var readiness = ConfigurationState.isReady();
    if (!readiness.ready) {
      _showNotification(readiness.reason || 'Please select your size and quantity.', 'error');
      return;
    }

    _executeAddToCart();
  }

  function _onCustomizationComplete(data) {
    void data;
    _awaitingCustomizationDecision = false;
    _executeAddToCart();
  }

  function _executeAddToCart() {
    _isProcessing = true;
    _setATCButtonState('loading');

    var config = ConfigurationState.getConfiguration();
    var payload;

    try {
      payload = CartPayloadBuilder.build(config);
    } catch (err) {
      _isProcessing = false;
      _setATCButtonState('default');
      _showNotification('Failed to build cart payload: ' + err.message, 'error');
      return;
    }

    CartAPI.addItems(payload).then(function(result) {
      if (!result.ok) {
        _onAddFailure(result);
        return;
      }

      return CartValidator.verifyAfterAdd(payload, result.response).then(function(verification) {
        if (!verification.valid && verification.issues && verification.issues.length > 0) {
          console.warn('[JRSBASE-V8.3.0-09102026-BYOB] JRS PDPController: Post-add verification found issues:', verification.issues);
        }
        _onAddSuccess(result);
      });
    }).catch(function(err) {
      _onAddFailure({ ok: false, error: err && err.message ? err.message : 'Unknown error', response: null });
    });
  }

  function _onAddSuccess(result) {
    void result;
    _isProcessing = false;
    _setATCButtonState('success');
    // Run 3 — fire post_add_complete. On this path variantaug's original
    // behaviour IS the redirect, so BOTH arms navigate to /cart (the router
    // does it on the redirect arm; we do it on the modal arm).
    if (window.JRS && JRS.PostAdd && typeof JRS.PostAdd.complete === 'function') {
      if (JRS.PostAdd.complete({ path: 'pdp_standard' }) === 'redirect') return;
    }
    window.location.href = '/cart';
  }

  function _onAddFailure(result) {
    _isProcessing = false;
    _setATCButtonState('default');
    _showNotification((result && result.error) || 'Failed to add to cart. Please try again.', 'error');
  }

  function _showNotification(message, type) {
    var container = document.querySelector('[data-jrs-notification]');
    if (!container) return;

    container.textContent = message;
    container.className = 'jrs-notification jrs-notification--' + type + ' jrs-notification--visible';

    if (type !== 'error') {
      setTimeout(function() {
        container.classList.remove('jrs-notification--visible');
      }, 5000);
    }
  }

  function _setATCButtonState(state) {
    if (!_sectionEl) return;
    var btn = _sectionEl.querySelector('[data-jrs-atc-button]');
    if (!btn) return;

    btn.disabled = state === 'loading' || state === 'disabled';

    var textEl = btn.querySelector('[data-jrs-atc-text]');
    if (!textEl) return;

    if (state === 'loading') {
      textEl.textContent = 'Adding...';
      btn.classList.add('jrs-atc--loading');
      btn.classList.remove('jrs-atc--success');
      return;
    }

    if (state === 'success') {
      textEl.textContent = 'Added!';
      btn.classList.remove('jrs-atc--loading');
      btn.classList.add('jrs-atc--success');
      return;
    }

    if (state === 'disabled') {
      textEl.textContent = 'Unavailable';
      btn.classList.remove('jrs-atc--loading');
      btn.classList.remove('jrs-atc--success');
      return;
    }

    textEl.textContent = _isCustomizable ? 'Customise & Add to Cart' : 'Add to Cart';
    btn.classList.remove('jrs-atc--loading');
    btn.classList.remove('jrs-atc--success');
  }

  function _setATCButtonEnabled(enabled) {
    if (!_sectionEl) return;
    var btn = _sectionEl.querySelector('[data-jrs-atc-button]');
    if (!btn) return;
    btn.disabled = !enabled;
    if (!enabled) {
      _setATCButtonState('disabled');
    } else {
      _setATCButtonState('default');
    }
  }

  function _bindListener(el, event, handler) {
    if (!el || !event || !handler) return;
    el.addEventListener(event, handler);
    _boundListeners.push({ el: el, event: event, handler: handler });
  }

  function _destroyListeners() {
    for (var i = 0; i < _boundListeners.length; i++) {
      var item = _boundListeners[i];
      if (!item || !item.el) continue;
      item.el.removeEventListener(item.event, item.handler);
    }
    _boundListeners = [];
  }

  function _destroyEventSubscriptions() {
    for (var i = 0; i < _eventUnsubs.length; i++) {
      var unsub = _eventUnsubs[i];
      if (typeof unsub === 'function') {
        try {
          unsub();
        } catch (error) {
          console.error('[JRSBASE-V8.3.0-09102026-BYOB] JRS PDPController: Failed to unsubscribe event', error);
        }
      }
    }
    _eventUnsubs = [];
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  JRS.PDPController = {
    init: init,
    destroy: destroy
  };
})(window.JRS);
